// Classes Tailwind partagées par les écrans d'administration (thème Noir/Or).
export const inputClass =
  'w-full bg-transparent border border-black/15 focus:border-gold focus:outline-none ' +
  'rounded-none px-4 py-3 text-foreground placeholder:text-foreground/40 transition-colors';
export const labelClass = 'block text-xs uppercase tracking-widest text-foreground/50 mb-2';
export const cardClass = 'border border-black/10 bg-white p-5';
export const thClass = 'text-left text-xs uppercase tracking-widest text-foreground/40 font-normal py-3 px-4';
export const tdClass = 'py-3 px-4 text-sm text-foreground/80 border-t border-black/5';

export const STATUS_LABELS = {
  pending: 'En attente',
  paid: 'Payée',
  confirmed: 'Confirmée',
  processing: 'En préparation',
  shipped: 'Expédiée',
  delivered: 'Livrée',
  completed: 'Terminée',
  cancelled: 'Annulée',
  canceled: 'Annulée',
  refunded: 'Remboursée',
  failed: 'Échouée',
  requested: 'Demandé',
  approved: 'Approuvé',
  received: 'Reçu',
  rejected: 'Refusé',
};

export const euro = (n) =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(n || 0));
